import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

const API_NOTIFICATIONS_URL = `${environment.apiUrl}/Notifications`;

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    constructor(private http: HttpClient) {
    }

    getNotifications(): Observable<any> {
        return this.http.get(API_NOTIFICATIONS_URL + '/GetNotifications');
    }

    updateNotificationStatus(input: any): Observable<any> {
        return this.http.put(API_NOTIFICATIONS_URL + '/UpdateNotificationStatus', input);
    }
}
